module.exports = __webpack_public_path__ + "static/media/10.3e921863.jpg";